import * as React from 'react';
import styles from './index.less';
import { type PopoverProps, Popover } from 'antd';

interface FPopoverProps extends PopoverProps {}

function FPopover({ rootClassName = '', ...props }: FPopoverProps) {
  return <Popover {...props} rootClassName={[styles.styles, rootClassName].join(' ')} />;
}

export default FPopover;
